import { render, staticRenderFns } from "./TagIconPicker.vue?vue&type=template&id=7d06bd47&scoped=true&"
import script from "./TagIconPicker.vue?vue&type=script&lang=ts&"
export * from "./TagIconPicker.vue?vue&type=script&lang=ts&"
import style0 from "./TagIconPicker.vue?vue&type=style&index=0&id=7d06bd47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d06bd47",
  null
  
)

export default component.exports